export default __webpack_public_path__ + "images/360fd00b35b5b3c3bd96262273c6e82b-shintoism.jpg";